<div class="login-wrapper">
    <!-- Warehouse Effects -->
    <div class="warehouse-effects">
        <div class="storage-rack"></div>
        <div class="pallet-jack"></div>
        <div class="scanning-beam"></div>
    </div>
    
    <!-- Particles Background -->
    <div class="particles">
        <div class="particle particle-1"></div>
        <div class="particle particle-2"></div>
        <div class="particle particle-3"></div>
        <div class="particle particle-4"></div>
        <div class="particle particle-5"></div>
    </div>

    <div class="login-container animate__animated animate__fadeIn">
        <!-- Left Panel -->
        <div class="login-panel">
            <div class="panel-content">
                <div class="logo-wrapper">
                    <img src="assets/images/logo/logo-icon.png" alt="Logo" class="logo-pulse">
                    <h1 class="brand-name mb-3">WAREHOUSE</h1>
                    <div class="barcode"></div>
                </div>
                <div class="panel-text">
                    <h2>Optimize Your Inventory</h2>
                    <p>Enterprise-grade warehouse management solution with real-time analytics</p>
                </div>
                <div class="panel-features">
                    <div class="feature">
                        <i class="fas fa-pallet"></i>
                        <span>Pallet Management</span>
                    </div>
                    <div class="feature">
                        <i class="fas fa-barcode"></i>
                        <span>Barcode Scanning</span>
                    </div>
                    <div class="feature">
                        <i class="fas fa-warehouse"></i>
                        <span>Storage Optimization</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Right Form Panel -->
        <div class="login-form-container">
            <form class="login-form" [formGroup]="loginForm" (ngSubmit)="login()" autocomplete="off">
                <div class="form-header">
                    <h3>Welcome Back</h3>
                    <p>Sign in to your warehouse management system </p>
                </div>

                <!-- Email Input -->
                <div class="form-group animate__animated animate__fadeInRight">
                    <div class="input-wrapper">
                        <i class="input-icon fas fa-envelope"></i>
                        <input type="email" id="email" placeholder=" " formControlName="email"
                            [ngClass]="{'input-error': (f['email'].touched || f['email'].dirty) && f['email'].errors}"
                            autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false">
                        <label for="email">Email Address</label>
                        <div class="input-bar"></div>
                    </div>
                    <div *ngIf="(f['email'].touched || f['email'].dirty) && f['email'].errors">
                        <span class="custom-text-danger">{{ f['email'].errors['required'] ? 'Email is required' : 'Please enter a valid email' }}</span>
                    </div>
                </div>

                <!-- Password Input -->
                <div class="form-group animate__animated animate__fadeInRight animate__delay-1s">
                    <div class="input-wrapper">
                        <i class="input-icon fas fa-lock"></i>
                        <input [type]="showPassword ? 'text' : 'password'" id="password" placeholder=" "
                            formControlName="password"
                            [ngClass]="{'input-error': (f['password'].touched || f['password'].dirty) && f['password'].errors}"
                            autocomplete="new-password" autocorrect="off" autocapitalize="none" spellcheck="false">
                        <label for="password">Password</label>
                        <div class="input-bar"></div>
                        <button type="button" class="password-toggle" (click)="togglePasswordVisibility()">
                            <i class="fas" [ngClass]="{'fa-eye': !showPassword, 'fa-eye-slash': showPassword}"></i>
                        </button>
                    </div>
                    <div *ngIf="(f['password'].touched || f['password'].dirty) && f['password'].errors">
                        <span class="custom-text-danger">{{ f['password'].errors['required'] ? 'Password is required' : 'Minimum 6 characters required' }}</span>
                    </div>
                </div>

                <!-- Login Button -->
                <button class="login-button animate__animated animate__fadeInUp animate__delay-3s"
                    [disabled]="loginForm.invalid || isLoading">
                    <span class="button-content" *ngIf="!isLoading">
                        <span>Login</span>
                        <i class="fas fa-arrow-right button-icon"></i>
                    </span>
                    <span class="loading-content" *ngIf="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                        <span>SECURE LOGIN</span>
                    </span>
                    <div class="button-hover-effect"></div>
                </button>

                <!-- Social Login Options -->
                <div class="social-login animate__animated animate__fadeInUp animate__delay-4s">
                    <div class="divider">
                        <span>OR CONTINUE WITH</span>
                    </div>
                    <div class="social-buttons">
                        <button type="button" class="social-button google">
                            <i class="fab fa-google"></i>
                        </button>
                        <button type="button" class="social-button microsoft">
                            <i class="fab fa-windows"></i>
                        </button>
                        <button type="button" class="social-button sso">
                            <i class="fas fa-id-card"></i>
                        </button>
                    </div>
                </div>
            </form>

            <!-- Footer Links -->
            <div class="login-footer animate__animated animate__fadeInUp animate__delay-5s">
                <p>Don't have an account? <a [routerLink]="'/auth/register'" class="register-link">Create one</a></p>
                <div class="footer-links">
                    <a href="#">Terms</a>
                    <a href="#">Privacy</a>
                    <a href="#">Help</a>
                </div>
            </div>
        </div>
    </div>
</div>